var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "48px",
        height: "46px",
        viewBox: "0 0 48 46",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Final",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Fall---Active",
                transform: "translate(1.000000, 1.000000)",
                stroke: "#000000",
                "stroke-width": "2"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M20.5,30.776 C20.5,32.4328542 19.1568542,33.776 17.5,33.776 L3.5,33.776 C1.84314575,33.776 0.5,32.4328542 0.5,30.776 L9.542,0.934 C9.66870339,0.510724869 10.0581679,0.220768199 10.5,0.220768199 C10.9418321,0.220768199 11.3312966,0.510724869 11.458,0.934 L20.5,30.776 Z",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M10.4999997,30.776 C10.4993964,28.7622343 11.3660852,26.8457539 12.8786057,25.5162675 C14.3911263,24.1867811 16.402948,23.5730872 18.4,23.832",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M2.6,23.834 C4.59670598,23.5751321 6.6081946,24.1885674 8.12064292,25.5176075 C9.63309124,26.8466475 10.5,28.7625832 10.5,30.776",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M10.4999999,21.776 C10.4997453,20.3184679 11.1354968,18.9333815 12.2408344,17.9833139 C13.346172,17.0332462 14.811047,16.6127872 16.252,16.832",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M4.724,16.834 C6.16835675,16.6070861 7.63966827,17.0237333 8.75059787,17.9742551 C9.86152747,18.9247769 10.5007558,20.3139276 10.5000007,21.776",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { id: "Oval", cx: "32.5", cy: "17.776", r: "13" }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M32.5,27.776 C32.5222553,24.6212535 34.5229982,21.8202133 37.5,20.776",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M27.5,17.776 C30.2614237,17.776 32.5,20.0145763 32.5,22.776",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "32.5",
                  y1: "43.776",
                  x2: "32.5",
                  y2: "13.776",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "10.5",
                  y1: "43.776",
                  x2: "10.5",
                  y2: "11.776",
                  id: "Path"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92acd9d2", { render: render, staticRenderFns: staticRenderFns })
  }
}